import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useInView } from '../hooks/useInView';
import { images } from '../data/translations';

export default function TwoVerticals() {
  const { t } = useLanguage();
  const [ref, isInView] = useInView();

  const cards = [
    { data: t.verticals.card1, img: images.card1 },
    { data: t.verticals.card2, img: images.card2 },
    { data: t.verticals.card3, img: images.card3 },
  ];

  return (
    <section
      ref={ref}
      data-testid="two-verticals"
      className="py-16 bg-[#1A1A2E]"
    >
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8">
        {cards.map((card, i) => (
          <div
            key={i}
            data-testid={`vertical-card-${i + 1}`}
            className={`group relative overflow-hidden rounded-lg border border-white/5 transition-all duration-500 ${
              isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: `${i * 150}ms` }}
          >
            {/* Top image area */}
            <div className="relative h-56 overflow-hidden">
              <img
                src={card.img}
                alt={card.data.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F1629] via-[#0F1629]/30 to-transparent" />
            </div>

            {/* Text content */}
            <div className="relative z-10 p-8 bg-[#0F1629]">
              <div className="w-12 h-0.5 bg-[#E71C25] mb-5" />
              <h3 className="text-2xl font-bold mb-4 tracking-tight">{card.data.title}</h3>
              <p className="text-[#B0B0B0] leading-relaxed text-[15px]">{card.data.copy}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
